// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"635":"d0767a0a","934":"ee4d635e"}[chunkId] + ".chunk.js";
};